const d = /-?(?:\d+(?:\.\d+)?|\.\d+)/gu;
export {
  d as floatRegex
};
